import LoadingSpinner from './LoadingSpinner';

/**
 * Loading fallback for lazy-loaded routes
 * Shows spinner while chunk is downloading
 */
export const LazyLoadFallback = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        width: '100%',
      }}
    >
      <LoadingSpinner />
    </div>
  );
};
